import React from 'react';
import { FAQ } from '../components/FAQ';
import { useScreenInit } from '../useScreenInit';
import { PricingSection } from '../components/PricingSection';
import { PricingCreditsUseCases } from '../components/PricingCreditsUseCases';
import { PricingClosingCTA } from '../components/PricingClosingCTA';
export function Pricing() {
  useScreenInit('Pricing');
  return <div className="min-h-screen bg-[#FAF8F4] pt-16" data-id="element-11236" data-mp="3v6y5nvfo4z01">
      <PricingSection data-id="element-11237" data-mp="3r7ytbprlxzyk" />

      <PricingCreditsUseCases data-id="element-11238" data-mp="3r8id7c0tiyf8" />

      <div className="bg-[#FAF8F4] pb-24" data-id="element-11239" data-mp="3m8dtze8izplb">
        <div className="mx-auto max-w-6xl px-6 md:px-10" data-id="element-11240" data-mp="3m7b5fcyodz8k">
          {/* FAQ. Warm hairline and a left-aligned heading, matching every
           other section on the page — a centred heading over a left-aligned
           accordion was the last place the page changed axis. */}
          <div className="border-t border-[#E4DACB] pt-20" data-id="element-11241" data-mp="1fhwkkbukw859">
            <h2 className="mb-10 font-title text-[30px] font-bold tracking-[-0.025em] text-[#2B211A] md:text-[40px]" data-id="element-11242" data-mp="1ffabg7s1hkkx">
              Frequently Asked Questions
            </h2>
            <FAQ data-id="element-11243" data-mp="1ekn8ludp4139" />
          </div>
        </div>
      </div>

      <PricingClosingCTA data-id="element-11244" data-mp="1jlb711497k7i" />
    </div>;
}